import React from 'react';

const UserIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.99967 7.00016C8.84134 7.00016 10.333 5.5085 10.333 3.66683C10.333 1.82516 8.84134 0.333496 6.99967 0.333496C5.15801 0.333496 3.66634 1.82516 3.66634 3.66683C3.66634 5.5085 5.15801 7.00016 6.99967 7.00016ZM6.99967 8.66683C4.77467 8.66683 0.333008 9.78349 0.333008 12.0002V13.6668H13.6663V12.0002C13.6663 9.78349 9.22467 8.66683 6.99967 8.66683Z" fill="currentColor"/>
    </svg>
  )
}

export default UserIcon;